import React, { useState, useEffect, useRef } from 'react';
import { Grid, Paper, Button } from '@mui/material';
import "../../../Static/priceinfo.css";
import ReactToPrint from "react-to-print";

import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import axios from "axios";
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { useParams } from "react-router-dom";


const QuotDiscountPerView = () => {
  const { mqtId, mil_pct, scr_pct, quot_no, mqtDisNo, dt } = useParams();
  const componentRef = useRef();

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [quotationlist, setQuotationList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageRange, setPageRange] = useState([0, 10]);
  const [searchTerm, setSearchTerm] = useState('');


  // ================= API CALL =================
  useEffect(() => {
    if (mqtId && quot_no && mqtDisNo && dt) {
      fetchData();
    }
  }, [mqtId, quot_no, mqtDisNo, dt])
  const fetchData = async () => {
    try {

      const res = await axios.get(baseUrl, {
        params: {
          apicall: "getmultiqtdiscountDatabyId",
          mqtId: mqtId?.trim(),
          mil_pct: mil_pct?.trim(),
          scr_pct: scr_pct?.trim(),
          quot_no: quot_no?.trim(),
          mqtDisNo: mqtDisNo?.trim(),
          dt: dt?.trim()
        }
      });

      //console.log("DETAIL DATA =>",res.data);
      setQuotationList(res?.data?.data || []);

    }
    catch (err) {
      console.log("API ERROR =>", err);
    }
  }

  // ================= VIEW BUTTON =================

  // ================= SAFE FILTER =================
  const filteredData = quotationlist.filter(item =>
    (item?.size || '').toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item?.mil_rate || '').toString().includes(searchTerm) ||
    (item?.dis_mil_rate || '').toString().includes(searchTerm) ||
    (item?.mil_pct || '').toString().includes(searchTerm) ||
    (item?.retailer_rate || '').toString().includes(searchTerm) ||
    (item?.retailer_pct || '').toString().includes(searchTerm) ||
    (item?.dis_retailer_rate || '').toString().includes(searchTerm) ||
    (item?.mrp_rate || '').toString().includes(searchTerm) ||
    (item?.mrp_pct || '').toString().includes(searchTerm) ||
    (item?.dis_mrp_rate || '').toString().includes(searchTerm) ||
    (item?.scr_rate || '').toString().includes(searchTerm) ||
    (item?.dis_scr_rate || '').toString().includes(searchTerm) ||
    (item?.scr_pct || '').toString().includes(searchTerm)
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const displayedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
  const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNextPageRange = () => {
    setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
  };

  const handlePreviousPageRange = () => {
    setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
  };


  // ================= UI =================
  return (
    <div style={{ margin: '1% 0.5%' }}>


      <Grid container spacing={2}>

        <Grid item xs={12}>
          <Paper style={{ padding: '3vh' }} ref={componentRef}>
            <h3 className="centered-heading">Multiple Quotation Discount Percentage View</h3>
            <div className="dashed-line"></div>
            <table style={{ margin: "1% 5%" }}>
              <tbody>
                <tr>
                  <td>Date</td>
                  <td className="light-color">{dt}</td>

                </tr>
                <tr>
                  <td>Multiple Quotation No</td>
                  <td className="light-color">{mqtDisNo}</td>
                  <td>Quot. No.</td>
                  <td className="dark-color">{quot_no}</td>
                </tr>
                <tr>
                  <td>Mil to Party (%)</td>
                  <td className="light-color">{mil_pct}</td>
                  <td>SCR to Mil (%)</td>
                  <td className="light-color">{scr_pct}</td>
                </tr>
              </tbody>
            </table>


            <div style={{ padding: '30px' }}></div>
            <SearchTable
              handleItemsPerPageChange={handleItemsPerPageChange}
              searchTerm={searchTerm}
              handleSearchChange={handleSearchChange}
              totalItems={filteredData?.length}
            />

            <TableContainer style={{ marginTop: '2%' }}>
              <Table>


                <TableHeader
                  headCells={[
                    { id: 'srno', label: 'SrNo' },
                    { id: 'size', label: 'Size' },
                    { id: 'scr_rate', label: 'SCR To Mil Rate' },
                    { id: 'scr_pct', label: `SCR To Mil (${scr_pct}%)` },
                    { id: 'dis_scr_rate', label: 'Dis SCR To Mil Rate' },
                    { id: 'mil_rate', label: 'Mil To Party Rate' },
                    { id: 'mil_pct', label: `Mil To Party (${mil_pct}%)` },

                    { id: 'dis_mil_rate', label: 'Dis Mil To party Rate' },
                    { id: 'retailer_rate', label: 'Retailer Rate' },
                    { id: 'retailer_pct', label: `Retailer (${mil_pct}%)` },
                    { id: 'dis_retailer_rate', label: 'Dis Retailer Rate' },
                    { id: 'mrp_rate', label: 'MRP Rate' },
                    { id: 'mrp_pct', label: `MRP (${mil_pct}%)` },
                    { id: 'dis_mrp_rate', label: 'Dis MRP Rate' },

                  ]}
                />

                <TableBody>
                  {displayedData.map((row, index) => (

                    <TableRow key={index}>

                      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                        {index + 1}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                        {row.size}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                        {row.scr_rate}
                      </TableCell>
                      <TableCell sx={{ p: 1, border: '1px solid #000', color: '#f00' }} align="center">
                        {row.scr_rate && row.scr_pct
                          ? ((parseFloat(row.scr_rate) * parseFloat(row.scr_pct)) / 100).toFixed(2)
                          : 0}</TableCell>
                      <TableCell sx={{ p: 1, border: '1px solid #000', color: 'blue' }} align="center">
                        {row.dis_scr_rate}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                        {row.mil_rate}
                      </TableCell>
                      <TableCell sx={{ p: 1, border: '1px solid #000', color: '#f00' }} align="center">
                        {row.mil_rate && row.mil_pct
                          ? ((parseFloat(row.mil_rate) * parseFloat(row.mil_pct)) / 100).toFixed(2)
                          : 0}
                      </TableCell>
                      <TableCell sx={{ p: 1, border: '1px solid #000', color: 'blue' }} align="center">
                        {row.dis_mil_rate}
                      </TableCell>



                      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                        {row.retailer_rate}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000', color: '#f00' }} align="center">
                        {row.retailer_rate && row.retailer_pct
                          ? ((parseFloat(row.retailer_rate) * parseFloat(row.retailer_pct)) / 100).toFixed(2)
                          : 0}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000', color: 'blue' }} align="center">
                        {row.dis_retailer_rate}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                        {row.mrp_rate}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000', color: '#f00' }} align="center">
                        {row.mrp_rate && row.mrp_pct
                          ? ((parseFloat(row.mrp_rate) * parseFloat(row.mrp_pct)) / 100).toFixed(2)
                          : 0}
                      </TableCell>

                      <TableCell sx={{ p: 1, border: '1px solid #000', color: 'blue' }} align="center">
                        {row.dis_mrp_rate}
                      </TableCell>





                    </TableRow>

                  ))}
                </TableBody>

              </Table>
            </TableContainer>

            <Pagination
              currentPage={currentPage}
              handlePageChange={handlePageChange}
              handlePreviousPageRange={handlePreviousPageRange}
              visiblePageNumbers={visiblePageNumbers}
              pageNumber={pageNumbers}
              pageRange={pageRange}
              totalPages={totalPages}
              handleNextPageRange={handleNextPageRange}
            />
            <div style={{ margin: "2% 5%", display: "flex", gap: "10px" }}>


              <ReactToPrint
                trigger={() => <Button variant="contained">Print</Button>}
                content={() => componentRef.current}
              />

            </div>
          </Paper>
        </Grid>
      </Grid>

    </div>
  );
}

export default QuotDiscountPerView;